export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">关于我们</h2>
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
            51动漫网创立于2020年，是国内领先的免费动漫在线观看平台。我们汇聚了超过20000部日漫、韩漫与国漫资源，
            覆盖热血战斗、异世界转生、修仙玄幻、恋爱日常、悬疑推理等全类型题材，致力于为每一位动漫爱好者
            提供高清流畅的在线观看体验。
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            平台独创的下拉式阅读模式让追更变得轻松自然，每日同步更新的番剧库确保你不会错过任何精彩内容。
            我们坚持完全免费的运营理念，拒绝任何形式的付费墙，因为动漫的魅力应该被所有人自由享受。
            无论你是资深二次元还是刚入坑的新朋友，51动漫网都是你探索动漫世界的最佳伙伴。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
            <div className="text-center">
              <p className="text-2xl font-heading text-primary-500">5年</p>
              <p className="text-xs text-foreground-500 mt-1">稳定运营</p>
            </div>
            <div className="w-px h-10 bg-background-300"></div>
            <div className="text-center">
              <p className="text-2xl font-heading text-primary-500">20000+</p>
              <p className="text-xs text-foreground-500 mt-1">动漫资源</p>
            </div>
            <div className="w-px h-10 bg-background-300"></div>
            <div className="text-center">
              <p className="text-2xl font-heading text-primary-500">500万+</p>
              <p className="text-xs text-foreground-500 mt-1">月活用户</p>
            </div>
            <div className="w-px h-10 bg-background-300"></div>
            <div className="text-center">
              <p className="text-2xl font-heading text-primary-500">99.9%</p>
              <p className="text-xs text-foreground-500 mt-1">服务可用</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}